import { render, staticRenderFns } from "./WidgetReviewsBestGalleryPc.vue?vue&type=template&id=677af098"
import script from "./WidgetReviewsBestGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsBestGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports